import React, {ChangeEventHandler, FC} from "react"
import RadioButton from "../elements/RadioButton"
import {useFormData} from "../../states/FormData"
import {useFormSteps} from "../../states/FormSteps";
import FlexDiv from "../elements/FlexDiv";

const Step1: FC = () => {

    const {familyOption, setFormData} = useFormData()
    const {nextStep} = useFormSteps()
    const handleSelectChange: ChangeEventHandler<HTMLInputElement> = (event) => {
        setFormData("familyOption", event.target.value)
        nextStep()
    }

    return (
        <>
            <span className={"survey-heading"}>In welcher Phase der Familiengründung befindest du dich gerade?</span>
            <FlexDiv>
                <RadioButton
                    name="family"
                    value="Kinderwunsch"
                    checked={familyOption === 'Kinderwunsch'}
                    onChange={handleSelectChange}
                    label={"Kinderwunsch"}
                />
                <RadioButton
                    name="family"
                    value="Schwangerschaft"
                    checked={familyOption === 'Schwangerschaft'}
                    onChange={handleSelectChange}
                    label={"Schwangerschaft"}
                />
                <RadioButton
                    name="family"
                    value="Stillzeit"
                    checked={familyOption === 'Stillzeit'}
                    onChange={handleSelectChange}
                    label={"Stillzeit & Säuglingsalter"}
                />
            </FlexDiv>
        </>
    )
}

export default Step1